import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 경로(pathname)가 바뀔 때마다 스크롤을 최상단(0, 0)으로 이동
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // 화면에 렌더링할 것은 없으므로 null 반환
}